module.exports = __webpack_public_path__ + "img/slovenia.e50ef7d0.svg";